export default "skymp5-front/acbf359fc87a619f76893cbbd23492c9.jpg";